import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';

export const filteredVenues = (venues: Venue[], keyword: string) => {
  const lowerCaseKeyword = keyword.toLowerCase();
  return venues.filter(item => {
    const { name, address } = item;
    return (
      name.some(({ value }) => value.toLowerCase().includes(lowerCaseKeyword)) ||
      address.toLowerCase().includes(lowerCaseKeyword)
    );
  });
};
